import { ServiceState } from '../../components/system/models/ServiceState';

define((require, exports, module) => {
    'use strict';

    const Service = require('system/Service');
    const BigdataServiceModel = require('./models/BigdataProject');

    const BigdataService = Service.extend({
        name: 'bigdata',

        serviceAvailabilityFeatureName: 'CLOUD_BIG_DATA_SERVICE',

        constructor: function BigdataService() {
            BigdataService.parent.call(this, {
                serviceState: new ServiceState({
                    createSingleModelInstance: () => new BigdataServiceModel(),
                    fetchSingleModelInstance: () =>
                        BigdataServiceModel.findOne(),
                }),
            });
        },
    });

    module.exports = BigdataService;
});
